// state.js

export default {
    sitesList: [],
    currentSite: {
        name: 'All Sites',
        value: 0,
        id: 1,
        lat: null,
        lon : null,
        tz : null,
        company_id: null,
    },
    timeZone: null,
};
